export default __webpack_public_path__ + "static/media/comment-icon.5837c370.svg";